import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container,IconButton } from '@mui/material';
import { QueuePlayNext } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { browserHistory } from '../../helpers/history';
import SimpleSelect from '../../components/select/simple';
import { FormattedMessage, injectIntl } from 'react-intl';
import Title from '../../components/title-name';
import * as Service from '../../services/defaultaction.service'
import * as componentActions from '../../redux/actions/integrationauths';
import Footer from '../../components/footer'
import 'react-quill/dist/quill.snow.css'; // ES6
import { PapiroConsole } from '../../utils/papiroConsole';
import * as IntegrationAuthService from "../../services/integrationauth.service";
import styled from 'styled-components';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Delete } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';

const NoDataRows = _ => {
  return (
    <div className="MuiDataGrid-window" style={{ display: 'flex', justifyContent: 'center', top: 56, overflowY: 'auto' }} >Não há registros a serem exibidos</div>
  )
}


const StyledTableContainer = styled(TableContainer)`
  width: 90%;
  margin: 20px auto;
`;

const StyledTable = styled(Table)`
  min-width: 650px;
  background-color: #ffffff;
`;

const StyledTableCell = styled(TableCell)`
  && {
    font-weight: bold;
    text-align: center;
    border: 1px solid #e0e0e0;  /* Linha de divisão */
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  && {
    text-align: center;
    border: 1px solid #e0e0e0;  /* Linha de divisão */
  }
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;


const StyledIconButton = styled(IconButton)`
  && {
    color: ${props => props.delete ? '#f44336' : '#277afe'};
    &:hover {
      color: ${props => props.delete ? '#e53935' : '#277afe'};
    }
  }
`;

class AuthenticationEdit extends Component {

  constructor(props) {
    super(props);
    const { userSession, integrationauths } = this.props;

    console.log("=== DA ===")
    console.log(integrationauths)
    console.log("integrationauths")
    console.log(this.props)

    this.globalAdm = false;
    this.isClient = true;
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    


    var list = integrationauths.integrationauth.integrationauthparams
    const renamedList = list.map(item => ({
      name: item.paramname ? item.paramname : item.name ,
      value: item.paramvalue ? item.paramvalue : item.value ,
      isEditable : false
    }));

    renamedList.push({  id: renamedList && renamedList.length > 0  ? renamedList.length + 1 : 2, name: '', value: '', isEditable: true});
    
   


    this.initialState = {
      updatedat: moment().format('YYYY/MM/DD HH:mm:ss'),
      updateduser: userSession.user.id,
      id: integrationauths.integrationauth.id,
      name: integrationauths.integrationauth.name,
      url: integrationauths.integrationauth.url,
      accessTokenFieldName: integrationauths.integrationauth.accesstokenfieldname,
      methodAuth: integrationauths.integrationauth.methodauth,
      dataType: integrationauths.integrationauth.datatype,
      contentType: integrationauths.integrationauth.contenttype,
      method: integrationauths.integrationauth.method,
    };

    this.state = {
      item: this.initialState,
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      methodAuthList: [],
      dataTypeList: [],
      contentTypeList: [],
      methodList: [],
      rows: renamedList,
      nextId: renamedList && renamedList.length > 0  ? renamedList.length + 1 : 2
     

    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
    
  }


  async componentDidMount() {

    await this.getData();


  };

  async getData() {
    this.setState({ loading: true })
    const result = await IntegrationAuthService.getData()
    if (result.success) {
      var data = result.data
      PapiroConsole.log("data here")
      PapiroConsole.log(data)
      this.setState({
        loading: false, methodAuthList: data.authenticationmethodintegration, dataTypeList: data.datatypeintegration, methodList: data.methodintegration, contentTypeList: data.contenttypeintegration

      })

    }
    else {
      const intl = this.props.intl;
      this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }

  }

  

  handleInputChange = e => {
    const name = e.target.name
    const value = e.target.value



    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }))
  }

  

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();

    this.setState(prevState => ({
      item: {
        ...prevState.item,
      }
    }))

    for (let key in this.state.item) {
      if (key.toString().toLowerCase().indexOf('id') > -1) {
        data.append(key, this.state.item[key]);
      } else if (key.toString().toLowerCase().indexOf('updateduser') > -1) {
        data.append(key, this.state.item[key]);
      } else if (key.toString().toLowerCase().indexOf('updatedat') > -1) {
        data.append(key, this.state.item[key]);
      } else if (key.toString().toLowerCase().indexOf('action') > -1) {
        data.append("text", this.state.item[key]);
      } else if (key.toString().toLowerCase().indexOf('active') > -1) {
        data.append(key, this.state.item[key]);
      }
      else if (key.toString().toLowerCase().indexOf('title') > -1) {
        data.append(key, this.state.item[key]);
      }
      
    }

    var result = await Service.editItem(data)
    if (result && result.success) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: intl.formatMessage({ id: "edit.success" })
      })
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  };

  closeNotification() {
    this.setState({ openNotification: false })
  }



  changeValues(stateName, value, text = '') {


    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }))
  }

  handleInputChangeTable = (e, id, field) => {
    const { value } = e.target;
    this.setState(prevState => ({
      rows: prevState.rows.map(row => (row.id === id ? { ...row, [field]: value } : row))
    }));
  };

  handleAddRow = id => {
    const { rows, nextId } = this.state;
    const row = rows.find(row => row.id === id);
    if (row.name && row.value) {
      this.setState(prevState => ({
        rows: prevState.rows.map(row => (row.id === id ? { ...row, isEditable: false } : row)).concat({ id: nextId, name: '', value: '', isEditable: true }),
        nextId: nextId + 1
      }));
    } else {
      alert('Preencha todos os campos antes de adicionar.');
    }
  };



  handleDeleteRow = id => {
    this.setState(prevState => ({
      rows: prevState.rows.filter(row => row.id !== id)
    }));
  };

  

 

 

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { item } = this.state;
    const intl = this.props.intl;
    const { rows } = this.state;
    PapiroConsole.log("this.state.OrgList")

    PapiroConsole.log(this.state.OrgList)
    PapiroConsole.log("state OrgListForDelete")

    PapiroConsole.log(this.state.OrgListForDelete)

    

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button variant='outlined' color='primary' onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {<FormattedMessage id="edit.default.action" />}
                <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                <Grid item xs={12} sm={12}>
                    <TextField inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({ id: "name" })} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={item.name} required />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <SimpleSelect label={intl.formatMessage({ id: "authentication.method" })} options={this.state.methodAuthList} stateName='methodAuth' changeSelect={this.changeValues} selected={this.state.item.methodAuth} required />
                  </Grid>


                  <Grid item xs={12} sm={12}>
                    <TextField inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({ id: "url" })} autoComplete='fname' variant='outlined' name='url' onChange={this.handleInputChange} value={item.url} required selected={this.state.item.url} />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <SimpleSelect label={intl.formatMessage({ id: "data.types" })} options={this.state.dataTypeList} stateName='dataType' changeSelect={this.changeValues} selected={this.state.item.dataType} required />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <SimpleSelect label={intl.formatMessage({ id: "content.type" })} options={this.state.contentTypeList} stateName='contentType' changeSelect={this.changeValues} selected={this.state.item.contentType} required />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <SimpleSelect label={intl.formatMessage({ id: "call.method" })} options={this.state.methodList} stateName='method' changeSelect={this.changeValues} selected={this.state.item.method} required />
                  </Grid>

                  <StyledTableContainer component={Paper}>
                    <StyledTable>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Nome</StyledTableCell>
                          <StyledTableCell>Valor</StyledTableCell>
                          <StyledTableCell>Ação</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map(row => (
                          <TableRow key={row.id}>
                            <StyledTableBodyCell>
                              <StyledTextField
                                value={row.name}
                                onChange={(e) => this.handleInputChangeTable(e, row.id, 'name')}
                                disabled={!row.isEditable}
                              />
                            </StyledTableBodyCell>
                            <StyledTableBodyCell>
                              <StyledTextField
                                value={row.value}
                                onChange={(e) => this.handleInputChangeTable(e, row.id, 'value')}
                                disabled={!row.isEditable}
                              />
                            </StyledTableBodyCell>
                            <StyledTableBodyCell>
                              {row.isEditable ? (
                                <StyledIconButton onClick={() => this.handleAddRow(row.id)}>
                                  <SaveIcon />
                                </StyledIconButton>
                              ) : (
                                <StyledIconButton delete onClick={() => this.handleDeleteRow(row.id)}>
                                  <Delete />
                                </StyledIconButton>
                              )}
                            </StyledTableBodyCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </StyledTable>
                  </StyledTableContainer>


                  <Grid item xs={12} sm={12}>
                    <TextField inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({ id: "access.token.field.name" })} autoComplete='fname' variant='outlined' name='accessTokenFieldName' onChange={this.handleInputChange} value={item.accessTokenFieldName} required />
                  </Grid>
                  <Grid item xs={12} sm={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Grid container justify="flex-end" spacing={2} style={{ justifyContent: 'flex-end' }}>
                      <Grid item xs={12} sm={4}    >
                        <Button
                          type='submit'
                          fullWidth
                          variant='contained'
                          color='primary'
                          className={classes.submit} >
                          {<FormattedMessage id="save" />}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>
            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}
            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />

            

          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

AuthenticationEdit.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  integrationauths: state.integrationauths
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AuthenticationEdit)));
